// components/admin/BannerList.js
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FiSearch, FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';
import { toast } from 'sonner';
import { handleImageUploadCloudOnly } from '../../../actions/upload/UploadCloud';
import AddBannerModal from '../../../modals/barnners/AddBannerModal';
import EditBannerModal from '../../../modals/barnners/EditBannerModal';
import DeleteBannerModal from '../../../modals/barnners/DeleteBannerModal';
import { createBarner, deleteBarner, getBarners, updateBarner } from '../../../redux/actions/barnnerActions';
import AdminLayout from '../../../components/layout/AdminLayout';



const BannerList = () => {
  const dispatch = useDispatch();
  const { banners, loading, error } = useSelector(state => state.banners);

  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);

  const [newBanner, setNewBanner] = useState({
    title: '',
    caption: '',
    imageUrl: '',
    linkUrl: '',
    type: 'home-slider',
    status: 'active',
    startDate: '',
    endDate: '',
    sortOrder: 0
  });

  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    const filters = { ...(searchTerm && { searchTerm }), startDate, endDate };
    dispatch(getBarners(filters));
  }, [dispatch, searchTerm, startDate, endDate]);

  const filtered = (banners || []).filter(b =>
    b.caption.includes(searchTerm) || b.title?.includes(searchTerm)
  );

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = await handleImageUploadCloudOnly(file);
      if (url) setNewBanner(prev => ({ ...prev, imageUrl: url }));
    }
  };

  const handleSubmit = async () => {
    if (!newBanner.caption || !newBanner.imageUrl || !newBanner.startDate || !newBanner.endDate) {
      toast.warn("Remplissez tous les champs");
      return;
    }
    await dispatch(createBarner(newBanner));
    setShowAddModal(false);
    // setNewBanner({ title: '', caption: '', imageUrl: '', linkUrl: '', startDate: '', endDate: '' });
    setImageFile(null);
  };

  const handleEdit = (b) => {
    setNewBanner({
      title: b.title,
      caption: b.caption,
      imageUrl: b.imageUrl,
      linkUrl: b.linkUrl,
      type: b.type,
      startDate: new Date(b.startDate).toISOString().split('T')[0],
      endDate: new Date(b.endDate).toISOString().split('T')[0],
      sortOrder: b.sortOrder
    });
    setSelectedBanner(b);
    setShowEditModal(true);
  };

  const handleUpdate = async () => {
    if (!newBanner.caption || !newBanner.imageUrl || !newBanner.startDate || !newBanner.endDate) {
      toast.warn("Remplissez tous les champs");
      return;
    }
    await dispatch(updateBarner(selectedBanner._id, newBanner));
    setShowEditModal(false);
    setSelectedBanner(null);
  };

  const handleDelete = (b) => {
    setSelectedBanner(b);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    await dispatch(deleteBarner(selectedBanner._id));
    setShowDeleteModal(false);
    setSelectedBanner(null);
  };

  return (
    <AdminLayout>
      
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="h3 mb-0">Gestion des Slides</h1>
          <p className="text-muted">Vous pouvez gérer les slides de votre site ici.</p>
        </div>
        <button className="btn btn-danger" onClick={() => setShowAddModal(true)}>
          <FiPlus /> Ajouter un Slide
        </button>
      </div>

      {/* Filtres */}
      <div className="card mb-4 shadow-sm">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-3">
              <label>Date début</label>
              <input type="date" className="form-control" value={startDate} onChange={e => setStartDate(e.target.value)} />
            </div>
            <div className="col-md-3">
              <label>Date fin</label>
              <input type="date" className="form-control" value={endDate} onChange={e => setEndDate(e.target.value)} />
            </div>
            <div className="col-md-6">
              <label>Rechercher</label>
              <div className="input-group">
                <span className="input-group-text"><FiSearch /></span>
                <input type="text" className="form-control" placeholder="Titre, texte..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="spinner"></div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Image</th>
                <th style={{ width: "150px" }}>Légende</th>
                <th style={{ width:"250px" }}>Description</th>
                <th>Dates</th>
                <th>Positionement</th>
                <th>Statut</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(b => (
                <tr key={b._id}>
                  <td><img src={b.imageUrl} alt="" style={{ height: '50px', width: '100px', objectFit: 'cover' }} /></td>
                  <td>{b.title||""}</td>
                  <td>{b.caption||""}</td>
                  <td>{new Date(b.startDate).toLocaleDateString()} → {new Date(b.endDate).toLocaleDateString()}</td>
                  <td>({b.sortOrder})</td>
                  <td>
                    <span className={`badge ${b.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                      {b.status}
                    </span>
                  </td>
                  <td className="text-end">
                    <button className="btn btn-sm btn-outline-warning me-2" onClick={() => handleEdit(b)}><FiEdit2 /></button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(b)}><FiTrash2 /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <AddBannerModal show={showAddModal} onHide={() => setShowAddModal(false)} onSubmit={handleSubmit} newBanner={newBanner} handleChange={(e) => setNewBanner({ ...newBanner, [e.target.name]: e.target.value })} handleFileChange={handleFileChange} />
      <EditBannerModal show={showEditModal} onHide={() => setShowEditModal(false)} onUpdate={handleUpdate} banner={selectedBanner} newBanner={newBanner} handleChange={(e) => setNewBanner({ ...newBanner, [e.target.name]: e.target.value })} handleFileChange={handleFileChange} />
      <DeleteBannerModal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} onDelete={confirmDelete} bannerName={selectedBanner?.caption} />

    </AdminLayout>
  );
};

export default BannerList;